export const PHONE_SUPPORT_DOUBTS_WHATSAPP = 5511910051289;
